import React, { useEffect, useState } from 'react';
import axios from 'axios';
import {
  Container,
  Typography,
  CircularProgress,
  Box,
  Paper,
  Button
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { useNavigate } from 'react-router-dom';
import DashboardLayout from '../../Sidebar/DashboardLayout';
import GenericTable from '../../../commun/GenericTable';
import ActionButtons from '../../../commun/ActionButtons';
import { showDeleteConfirmation } from '../../../commun/deletemsg'; 
import Pagination from '../../../commun/Pagination';
import './emailTemplates.css';
import Chatbox from '../../../commun/ChatBox';


const EmailTemplates = () => {
  const [page, setPage] = useState(1);
  const templatesperPage = 8;
  const [displayMode, setDisplayMode] = useState('table');
  const [templates, setTemplates] = useState([]);
  const paginatedtemplates = templates.slice((page - 1) * templatesperPage, page * templatesperPage);
  const [selectedRows, setSelectedRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const userRole = localStorage.getItem('userType');
  useEffect(() => {
    fetchTemplates();
  }, []);

  const fetchTemplates = () => {
    
    setLoading(true);
    axios
      .get(`${process.env.REACT_APP_API_BASE_URL}/api/admin/email-templates/with-usage`)
      .then((res) => setTemplates(res.data))
      .catch(() => setTemplates([]))
      .finally(() => setLoading(false));
  };

  const handleDelete = (id) => {
    showDeleteConfirmation({
      onConfirm: async () => {
        try {
          await axios.delete(`${process.env.REACT_APP_API_BASE_URL}/api/admin/email-templates/${id}`);
          // ecriture dans JSON
          await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/admin/email-templates/save-json`);
          fetchTemplates();
        } catch (error) {
          alert("Erreur lors de la suppression.");
        }
      },
      onCancel: () => {
      }
    });
  };

  const columns = [
    { key: 'nom', label: 'Nom' },
    { key: 'sujet', label: 'Sujet' },
    { key: 'type', label: 'Type', render: (val) => val.toUpperCase() }
  ];

  const renderActions = (row) => (
    <ActionButtons
      showView={true}
      onView={() => navigate(`/admin/email-templates/view/${row._id}`)}
      onEdit={() => navigate(`/admin/email-templates/${row._id}`)}
        onDelete={row.usedInCode ? null : () => handleDelete(row._id)}
    />
  );

  return (
    <DashboardLayout>
      <Container maxWidth="lg">
        <Box className="email-template-header">
          <Typography variant="h4" className="email-template-title">
            Modèles d'e-mails
          </Typography>
          <Button
            variant="contained"
            startIcon={<AddIcon />}
            onClick={() => navigate('/admin/email-templates/add')}
          >
            Ajouter un modèle
          </Button>
        </Box>

        {loading ? (
          <Box display="flex" justifyContent="center" mt={4}>
            <CircularProgress />
          </Box>
        ) : (
          <>
          <Paper elevation={1} className="contact-table">
          <GenericTable
              columns={columns}
              data={paginatedtemplates}
              renderActions={renderActions}
              displayMode={displayMode}
              setDisplayMode={setDisplayMode}
              totalItems={templates.length}
              selectedRows={selectedRows}
              setSelectedRows={setSelectedRows}
            />
              <Pagination
                page={page}
                setPage={setPage}
                totalItems={templates.length}
                itemsPerPage={templatesperPage} />
                </Paper>
            </>
        )}
      </Container>
      {userRole !== 'agent' && <Chatbox userRole={userRole} />}
    </DashboardLayout>
  );
};

export default EmailTemplates;
